/*
 * Bestsellers-style product rows (Bestsellers and Related products).
 *
 * SliderComponent advances by a single data-step, read from the clicked arrow
 * at click time. A page is columns_mobile cards below 990px and
 * columns_desktop at or above it, so the step is set to the right one just
 * before the slider reads it.
 *
 * One delegated listener in the capture phase rather than a script per
 * section: Related products is fetched and swapped in by
 * <product-recommendations> after load, and scripts inside swapped-in HTML
 * never run. Capture runs before SliderComponent's own click handler.
 */
(() => {
  if (window.bestsellersSliderReady) return;
  window.bestsellersSliderReady = true;

  const desktop = window.matchMedia('(min-width: 990px)');

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-step-desktop]');
      if (!button) return;
      const step = desktop.matches ? button.dataset.stepDesktop : button.dataset.stepMobile;
      if (step) button.dataset.step = step;
    },
    true
  );
})();
